import * as React from "react";
import { LucideIcon, Sparkles } from "lucide-react";
import { cn } from "@/lib/utils";

export interface HoloBadgeProps {
  label: "Dynamic" | "Personalized" | string;
  size?: "sm" | "md";
  /** Defaults to the sparkles that mark anything dynamic. */
  icon?: LucideIcon;
  className?: string;
}

/** A pill with the static holo gradient border; marks anything dynamic. */
export const HoloBadge: React.FC<HoloBadgeProps> = ({ label, size = "sm", icon: Icon = Sparkles, className }) => (
  <span data-slot="holo-badge" className={cn("inline-flex rounded-full bg-holo-conic p-px", className)}>
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full bg-white font-semibold text-slate-700 whitespace-nowrap",
        size === "sm" ? "px-2 py-0.5 text-[11px]" : "px-2.5 py-1 text-xs"
      )}
    >
      <Icon className={size === "sm" ? "size-3" : "size-3.5"} aria-hidden="true" />
      {label}
    </span>
  </span>
);
